const dismissDurationMs = 275;
const transitionWrapper = "_275tuczif5";
const wrapper = "_275w6m2igj";
const heading = "_275hp3v7ke";
const body = "_275b7yj0o8";
const inlineLink = "_275i1rbl6fe";

export { body, dismissDurationMs, heading, inlineLink, transitionWrapper, wrapper };
import "./atom.welcome-notice.style.linaria.module.css";
//# sourceMappingURL=atom.welcome-notice.style.js.map
